import React from 'react'

export const noAvailableIcon = <svg version="1.1" className="manualCallSvg" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	width="100%" height="100%" viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve">
	<g>
		<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="19.5005" y1="39.626" x2="19.5005" y2="8.0401">
			<stop offset="0" style={{ stopColor: "#FFFFFF" }} />
			<stop offset="1" style={{ stopColor: "#F2F2F2" }} />
		</linearGradient>
		<path fill="url(#SVGID_1_)" d="M20.164,31.001l-3.619-0.733c-0.746-0.15-1.48,0.191-1.869,0.799
  c-1.109-0.402-2.033-1.022-2.768-1.764C11.51,28.898,11.199,29,10.955,28h0.094C11.596,28,12,27.412,12,26.863v-8.379
  C12,17.935,11.596,18,11.049,18H9.65c-0.158,0-0.299-0.189-0.42-0.131c0.203-1.75,0.668-3.774,1.639-5.439
  c0.459,0.002,0.928-0.245,1.26-0.715c3.408-4.822,11.834-4.85,15.242-0.029c0.332,0.47,0.799,0.646,1.26,0.645
  c0.959,1.65,1.424,3.765,1.631,5.505C30.146,17.803,30.029,18,29.916,18H28.52C27.971,18,27,17.935,27,18.484v3.059
  c0-0.13,0.973-0.207,1.537-0.207c1.758,0,3.463,0.667,4.463,1.756V21.26c0-1.159-0.146-2.09-1.307-2.428
  c-0.004-0.072,0.133-0.143,0.129-0.215c-0.174-2.742-0.765-5.139-1.858-7.048c0.252-0.396,0.323-0.903-0.044-1.423
  c-2.418-3.416-6.053-4.985-10.188-5.029c-4.109-0.043-7.818,1.664-10.197,5.029c-0.367,0.521-0.327,1.029-0.075,1.423
  c-1.094,1.91-1.751,4.306-1.923,7.048c-0.012,0.161-0.148,0.32-0.154,0.477C6.666,19.543,6,20.328,6,21.26v2.827
  c0,1.397,1.33,2.475,2.551,2.562c0.02,0.087,0.107,0.176,0.131,0.267c0.01,0.265,0.13,0.552,0.28,0.778
  c0.332,0.88,0.892,1.858,1.772,2.757c0.949,0.967,2.15,1.695,3.578,2.184c0.084,0.755,0.65,1.405,1.432,1.564l3.622,0.733
  c0.969,0.195,1.919-0.436,2.116-1.403l0.084-0.411C21.762,32.15,21.133,31.197,20.164,31.001z"/>
		<circle fill="#FF0000" cx="29.151" cy="28.172" r="5.47" />
		<rect x="28.466" y="24.187" transform="matrix(0.7082 0.706 -0.706 0.7082 28.5988 -12.2775)" fill="#FFFFFF" width="1.371" height="8.54" />
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
</svg>

export const noAvailableSVG = <svg version="1.1" id="Layer_1" className="workBarItem" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	width="100%" height="100%" viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve">
	<g>
		<linearGradient className="workBarItem" id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="19.5005" y1="39.626" x2="19.5005" y2="8.0401">
			<stop offset="0" style={{ stopColor: "#FFFFFF" }} />
			<stop offset="1" style={{ stopColor: "#F2F2F2" }} />
		</linearGradient>
		<path className="workBarItem" fill="url(#SVGID_1_)" d="M20.164,31.001l-3.619-0.733c-0.746-0.15-1.48,0.191-1.869,0.799
			c-1.109-0.402-2.033-1.022-2.768-1.764C11.51,28.898,11.199,29,10.955,28h0.094C11.596,28,12,27.412,12,26.863v-8.379
			C12,17.935,11.596,18,11.049,18H9.65c-0.158,0-0.299-0.189-0.42-0.131c0.203-1.75,0.668-3.774,1.639-5.439
			c0.459,0.002,0.928-0.245,1.26-0.715c3.408-4.822,11.834-4.85,15.242-0.029c0.332,0.47,0.799,0.646,1.26,0.645
			c0.959,1.65,1.424,3.765,1.631,5.505C30.146,17.803,30.029,18,29.916,18H28.52C27.971,18,27,17.935,27,18.484v3.059
			c0-0.13,0.973-0.207,1.537-0.207c1.758,0,3.463,0.667,4.463,1.756V21.26c0-1.159-0.146-2.09-1.307-2.428
			c-0.004-0.072,0.133-0.143,0.129-0.215c-0.174-2.742-0.765-5.139-1.858-7.048c0.252-0.396,0.323-0.903-0.044-1.423
			c-2.418-3.416-6.053-4.985-10.188-5.029c-4.109-0.043-7.818,1.664-10.197,5.029c-0.367,0.521-0.327,1.029-0.075,1.423
			c-1.094,1.91-1.751,4.306-1.923,7.048c-0.012,0.161-0.148,0.32-0.154,0.477C6.666,19.543,6,20.328,6,21.26v2.827
			c0,1.397,1.33,2.475,2.551,2.562c0.02,0.087,0.107,0.176,0.131,0.267c0.01,0.265,0.13,0.552,0.28,0.778
			c0.332,0.88,0.892,1.858,1.772,2.757c0.949,0.967,2.15,1.695,3.578,2.184c0.084,0.755,0.65,1.405,1.432,1.564l3.622,0.733
			c0.969,0.195,1.919-0.436,2.116-1.403l0.084-0.411C21.762,32.15,21.133,31.197,20.164,31.001z"/>
		<circle className="workBarItem" fill="#FF0000" cx="29.151" cy="28.172" r="5.47" />
		<rect fill="#FFFFFF" className="workBarItemTransparent" x="28.466" y="24.187" transform="matrix(0.7082 0.706 -0.706 0.7082 28.5988 -12.2775)" width="1.371" height="8.54" />
	</g>
</svg>

export const noAvailableRecordIcon = <svg version="1.1" className="workBarItem" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	width="100%" height="100%" viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve">
	<g>
		<linearGradient className="workBarItem" id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="19.5005" y1="36.9004" x2="19.5005" y2="5.9492">
			<stop offset="0" style={{ stopColor: "#F2F2F2" }} />
			<stop offset="1" style={{ stopColor: "#FFFFFF" }} />
		</linearGradient>
		<path className="workBarItem" fill="url(#SVGID_1_)" d="M19.962,30.947l-3.629-0.735c-0.748-0.151-1.485,0.19-1.874,0.8
		c-1.113-0.402-2.04-0.994-2.775-1.736C11.282,28.87,10.974,29,10.727,28h0.093C11.368,28,12,27.348,12,26.797v-8.403
		C12,17.842,11.368,18,10.819,18H9.418c-0.157,0-0.299-0.234-0.422-0.178c0.205-1.754,0.672-3.807,1.644-5.478
		c0.462,0.002,0.931-0.258,1.265-0.729c3.417-4.834,11.867-4.868,15.285-0.034c0.334,0.472,0.803,0.646,1.265,0.644
		c0.96,1.656,1.428,3.82,1.636,5.565C29.975,17.758,29.857,18,29.742,18h-1.4C27.791,18,27,17.842,27,18.394v2.735
		c1-0.094,0.825-0.145,1.315-0.145c1.852,0,3.685,0.719,4.685,1.885v-1.692c0-1.161-0.229-2.095-1.392-2.435
		c-0.004-0.071,0.091-0.143,0.087-0.215c-0.174-2.749-0.785-5.154-1.881-7.068c0.251-0.396,0.31-0.906-0.058-1.426
		c-2.424-3.428-6.076-5-10.223-5.045c-4.121-0.043-7.841,1.669-10.229,5.045c-0.367,0.521-0.327,1.031-0.079,1.426
		c-1.094,1.916-1.753,4.319-1.927,7.068c-0.01,0.162-0.027,0.321-0.033,0.479C6.547,19.456,6,20.243,6,21.177v2.837
		c0,1.4,1.213,2.48,2.436,2.568c0.021,0.088,0.047,0.176,0.072,0.268c0.01,0.265,0.102,0.553,0.252,0.779
		c0.333,0.883,0.878,1.864,1.762,2.766c0.951,0.97,2.149,1.7,3.58,2.189c0.085,0.757,0.648,1.41,1.434,1.569l3.629,0.735
		c0.97,0.195,1.928-0.437,2.123-1.407l0.084-0.412C21.566,32.1,20.934,31.145,19.962,30.947z"/>
		<radialGradient className="workBarItem" id="SVGID_256_" cx="29.0098" cy="28.5781" r="9.5765" gradientUnits="userSpaceOnUse">
			<stop offset="0" style={{ stopColor: "#00D6FF" }} />
			<stop offset="0.3193" style={{ stopColor: "#00C1FF" }} />
			<stop offset="0.9782" style={{ stopColor: "#008AFF" }} />
			<stop offset="1" style={{ stopColor: "#0088FF" }} />
		</radialGradient>
		<path className="workBarItem" fill="url(#SVGID_256_)" d="M28.77,22.543c-3.102,0-5.613,2.518-5.613,5.619s2.512,5.619,5.613,5.619
		c3.108,0,5.625-2.518,5.625-5.619S31.878,22.543,28.77,22.543z"/>
		<path className="workBarItemTransparent" fill="#FFFFFF" d="M29.088,25.305H28.15v3.746l3.278,1.968l0.469-0.769l-2.81-1.667V25.305z" />
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
</svg>

export const infinito = <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	viewBox="0 0 14 12" enableBackground="new 0 0 14 12" xmlSpace="preserve">
	<path d="M10.7,2.7c-0.2,0-0.4,0-0.6,0.1C9.7,2.8,9.3,2.9,8.9,3c-1.1,0.5-2,1.4-2.6,2.8c-0.4,0.9-1,1.6-1.7,1.9C4,8,3.5,8,3.4,8
c0,0-0.1,0-0.1,0c-1.1,0-2-0.9-2-2s0.9-2,2-2s2.1,0.9,2.1,2c0,0,0,0,0,0.1c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.4,0.4-0.8,0.6-1.1
c-0.6-1.1-1.7-1.8-3-1.8C1.5,2.7,0,4.2,0,6c0,1.8,1.5,3.3,3.3,3.3c0.1,0,0.2,0,0.3,0C4,9.3,4.5,9.2,5.1,9c1-0.5,1.8-1.4,2.4-2.6l0,0
c0.4-1,1.1-1.7,1.9-2.1C9.9,4.1,10.3,4,10.6,4c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2S8.4,7.1,8.4,6c0,0,0,0,0,0C8.3,6.2,8.2,6.4,8.1,6.6
l0,0C8,6.9,7.8,7.2,7.7,7.5c0.5,1.1,1.7,1.9,3,1.9C12.5,9.3,14,7.8,14,6C14,4.2,12.5,2.7,10.7,2.7z"/>
</svg>

export const clock2 = <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	viewBox="0 0 12 12" enableBackground="new 0 0 12 12" xmlSpace="preserve">
	<g>
		<path d="M3.3,2.1L2.4,1.2l0,0C0.9,2.3,0,4,0,6c0,3.3,2.7,6,6,6s6-2.7,6-6S9.3,0,6,0H5.3v2.7h1.3V1.4c2.3,0.3,4,2.3,4,4.6
		c0,2.6-2.1,4.7-4.7,4.7S1.3,8.6,1.3,6c0-1.1,0.4-2.1,1.1-2.9C2.4,3,2.7,2.5,3.3,2.1z"/>
		<path d="M6.4,5.1L3.7,3.5l1.7,2.6c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.7-0.3,0.7-0.7C6.7,5.5,6.5,5.3,6.4,5.1z" />
	</g>
</svg>


// WEBPACK FOOTER //
// ./src/Images/NoAvailableSVG.js